import { EntityModel } from '@/interfaces'
import {
  ALL_BRANDINGS_QUERY,
  CREATE_BRANDING_MUTATION,
  DELETE_BRANDING_MUTATION,
  FORCE_DELETE_BRANDING_MUTATION,
  SINGLE_BRANDING_QUERY,
  UPDATE_BRANDING_MUTATION,
} from './graphql'
import mediaFileEntity from '@/entities/mediaFile/entity'

const travelPricingBrandingModel: EntityModel = {
  name: 'branding',
  namePlural: 'brandings',
  uniqueName: 'travelPricingBranding',
  uniqueNamePlural: 'travelPricingBrandings',
  path: 'travel/pricing/branding',
  baseUrl: '/travel/pricing/brandings',
  translationPrefix: 'entities:travelPricingBranding.',
  getDisplayName: (values: any) => {
    return 'BRANDING'
  },
  gql: {
    getAll: ALL_BRANDINGS_QUERY,
    getSingle: SINGLE_BRANDING_QUERY,
    create: CREATE_BRANDING_MUTATION,
    update: UPDATE_BRANDING_MUTATION,
    delete: DELETE_BRANDING_MUTATION,
    forceDelete: FORCE_DELETE_BRANDING_MUTATION,
  },
  attributes: {
    logo: {
      name: 'logo',
      label: 'entities:travelPricingBranding.attributes.logo.label',
      type: 'entityObject',
      dataType: 'any',
      getEntity: () => {
        return mediaFileEntity
      },
      defaultInput: false,
      inputType: 'select',
      validationType: 'string',
      validations: [],
    },
    logoWidth: {
      name: 'logoWidth',
      label: 'entities:travelPricingBranding.attributes.logoWidth.label',
      type: 'value',
      dataType: 'number',
      defaultValue: 130,
      defaultInput: true,
      inputType: 'number',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
  },
}

export default travelPricingBrandingModel
